import { Outlet } from "react-router-dom";
import { KairooDataProvider, useKairooData } from "../../contexts/KairooDataContext";
import { useIdleWarning, IdleWarningBanner } from "../../hooks/useIdleWarning";
import { ControlSidebar } from "./ControlSidebar";
import { ControlTopBar } from "./ControlTopBar";
import { OnboardingTourOverlay, OnboardingHelpButton } from "../onboarding/OnboardingTour";
import { useOnboardingTour } from "../onboarding/useOnboardingTour";
import { KAIROO_STEPS } from "../onboarding/onboardingSteps";

// UX-CP-01 §1 shell — reused by UX-CP-02's later screens, same shape as UX-01's gym AppShell
// (sidebar + glass top bar + idle-timeout warning, since every Kairoo session is privileged
// with the same 15-min idle timeout as a gym super_admin — session_utils.py's `is_privileged`).
function ControlPlaneShellInner() {
  const { me, loading, error } = useKairooData();
  const { warning, staySignedIn } = useIdleWarning();
  const tour = useOnboardingTour("kairoo", me?.login_count, me?.id);

  if (loading) {
    return <div className="scarlet-canvas min-h-screen flex items-center justify-center text-sm" style={{ color: "var(--scarlet-text-secondary)" }}>Loading Control Plane…</div>;
  }
  if (error) {
    return <div className="scarlet-canvas min-h-screen flex items-center justify-center text-sm" style={{ color: "var(--scarlet-neg)" }}>Couldn't load the Control Plane. Please refresh.</div>;
  }

  return (
    <div className="scarlet-canvas flex">
      <ControlSidebar />
      <div className="flex-1 min-w-0 pb-8">
        <ControlTopBar />
        <main className="px-8 pt-6" data-testid="control-shell-content">
          <Outlet />
        </main>
      </div>
      {warning && <IdleWarningBanner onStaySignedIn={staySignedIn} />}
      <OnboardingTourOverlay steps={KAIROO_STEPS} tour={tour} />
      <OnboardingHelpButton onClick={tour.restart} />
    </div>
  );
}

export function ControlPlaneShell() {
  return (
    <KairooDataProvider>
      <ControlPlaneShellInner />
    </KairooDataProvider>
  );
}
